export const INITIAL_STATS = {
  registrations: Array(7).fill(0),
  dailyActive: 0,
  totalUsers: 0,
  premiumUsers: 0,
  lite: { count: 0, sum: 0 },
  pro: { count: 0, sum: 0 },
  premium: { count: 0, sum: 0 },
  planPrices: { lite: 0, pro: 0, max: 0 }
};

export const INITIAL_ACTION_DATA = {
  balance: 0,
  premiumId: 1,
  premiumDays: 1
};

export const INITIAL_MAILING_DATA = {
  text: "",
  target: "all",
  attachments: ""
};

function createLocalId(prefix) {
  return `${prefix}_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function createRoulettePrize() {
  return {
    id: createLocalId("prize"),
    label: "Новый приз",
    rarity: "common",
    accent: "#7CE7FF",
    icon: "/roulette/tokens.svg",
    weight: 1,
    type: "tokens",
    value: 100,
    message: ""
  };
}

export function createPhotosessionStyle() {
  return {
    id: createLocalId("style"),
    title: "Новый стиль",
    prompt: "",
    previewAttachment: "",
    active: true,
    emoji: "✨",
    likes: 0,
    dislikes: 0
  };
}

export function createTemplatePrompt() {
  return {
    id: createLocalId("template"),
    emoji: "⚡",
    title: "Новый шаблон",
    prompt: "",
    active: true
  };
}

export function createMailingButton(type = "url", initial = {}) {
  return {
    id: createLocalId("mailing_button"),
    type,
    text: "",
    value: "",
    ...(initial && typeof initial === "object" ? initial : {})
  };
}

export function createTriggerRule(stage = "user_inactive") {
  const base = {
    id: createLocalId("trigger"),
    title: "Новый триггер",
    description: "",
    enabled: true,
    stage,
    messageKey: "",
    messageText: "",
    attachment: "",
    keyboardType: "none",
    keyboardData: {},
    frequency: {
      mode: "once",
      cooldownSec: 0,
      maxPerUser: 1
    },
    timing: {
      delaySec: 0,
      maxDelaySec: 0,
      ttlSec: 0,
      daysBeforeExpire: 0,
      requestCount: 0,
      withinSec: 0
    },
    conditions: {
      freeOnly: false,
      tokensThreshold: 0,
      grantTokens: 0,
      minBalanceAfterSend: 0,
      grantPaidSpins: 0,
      bonusCredits: 0
    }
  };

  if (stage === "user_inactive") {
    base.title = "Реактивация неактивных";
    base.keyboardType = "triger3";
    base.messageKey = "triger_1";
    base.timing.delaySec = 3 * 24 * 60 * 60;
    base.timing.maxDelaySec = 7 * 24 * 60 * 60;
    base.conditions.freeOnly = true;
    base.conditions.minBalanceAfterSend = 4000;
    base.conditions.grantPaidSpins = 1;
  }

  if (stage === "new_user_inactive") {
    base.title = "Подсказка новому пользователю";
    base.keyboardType = "templates";
    base.messageKey = "triger_new_user_1h";
    base.timing.delaySec = 60 * 60;
    base.timing.maxDelaySec = 7 * 24 * 60 * 60;
  }

  if (stage === "premium_expires") {
    base.title = "Напоминание о продлении";
    base.keyboardType = "triger2";
    base.messageKey = "triger_3";
    base.timing.daysBeforeExpire = 3;
  }

  if (stage === "premium_expired") {
    base.title = "Возврат после окончания подписки";
    base.keyboardType = "triger2";
    base.messageKey = "triger_4";
  }

  if (stage === "after_aha") {
    base.title = "Оффер после Aha";
    base.keyboardType = "ahaOffer";
    base.messageKey = "onMessage.aha_offer";
    base.conditions.freeOnly = true;
    base.conditions.tokensThreshold = 500;
  }

  if (stage === "session_requests") {
    base.title = "Подсказка про шаблоны";
    base.keyboardType = "templatesEntry";
    base.messageKey = "onMessage.session_templates_hint";
    base.timing.requestCount = 3;
    base.timing.withinSec = 30 * 60;
  }

  if (stage === "after_paywall_view") {
    base.title = "Напоминание после paywall";
    base.keyboardType = "paywallBonusClaim";
    base.messageText = "🎁 Только сегодня: +{{bonusCredits}} ИИ-фотосессии при покупке любой подписки.";
    base.frequency.mode = "repeat";
    base.frequency.maxPerUser = 0;
    base.frequency.cooldownSec = 0;
    base.timing.delaySec = 24 * 60 * 60;
    base.timing.ttlSec = 24 * 60 * 60;
    base.conditions.freeOnly = true;
    base.conditions.bonusCredits = 3;
  }

  return base;
}
